
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';

import { Typography, Box, Button, TextField, LinearProgress, Modal } from '@mui/material';
import { Menu as MainMenu } from '../../components/Menu';

import { getDocuments } from '../../api/documents';
import { useData } from '../../hooks/DataProvider';

import { DataGrid } from '@mui/x-data-grid';

import translations from '../../scripts/translations';

import { ModelDocumentData, ModelDocumentType, ModelDocumentStatus } from '../../models/ModelDocument';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    borderRadius: '8px',
    boxShadow: 24,
    p: 4,
};

const SelectDocumentType = ({ open, handleClose }) => {

    const { language } = useData();
    const page = translations.components.selectDocumentType[language];


    return (
        <Modal
            open={!!open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {open && <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    {page.title}
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', mt: 2, gap: 2 }}>

                    {Object.values(ModelDocumentType).map((type) => (
                        <Link to={`/documents/new?documentType=${type.key}`} key={type.key} style={{ textDecoration: 'none', color: 'inherit' }}>
                            <Button variant='outlined' sx={{ mr: 1 }}>
                                {type[language]}
                            </Button>
                        </Link>
                    ))}

                </Box>

            </Box>}
        </Modal>

    )
}


const Documents = () => {

    const { language } = useData();
    const btns = translations.button[language];
    const page = translations.pages.documents[language];

    const navigate = useNavigate();

    const [documents, setDocuments] = useState([]);

    const [documentsFilter, setDocumentsFilter] = useState({});
    const [loading, setLoading] = useState(false);

    const [popupDocument, setPopupDocument] = useState(false);

    const handleClosePopupDocument = () => {
        setPopupDocument(false);
    }

    const getLocalFilter = async () => {
        const localFilter = localStorage.getItem('documentsFilter');
        return localFilter ? JSON.parse(localFilter) : {};
    };

    const setLocalFilter = (filter) => {
        localStorage.setItem('documentsFilter', JSON.stringify(filter));
    };

    const updateDocumentsFilter = (newFilter) => {
        let currentFilter = {}
        if (newFilter.value === '') {
            currentFilter = { ...documentsFilter };
            delete currentFilter[newFilter.field];
            setDocumentsFilter(currentFilter)
        }
        else {
            currentFilter = { ...documentsFilter, [newFilter.field]: newFilter.value }
        }
        setDocumentsFilter(currentFilter)
        setLocalFilter(currentFilter);

    }

    const clearDocumentsFilter = () => {
        setDocumentsFilter({});
        setLocalFilter({});
        fetchDocuments({});
    };

    const fetchDocuments = async (filter) => {
        try {
            setLoading(true);
            let startTime = new Date().getTime();
            const response = await getDocuments(filter);
            setDocuments(response);

            console.log('Documents fetched successfully:', response);
            let endTime = new Date().getTime();
            console.log(`Fetch Documents took ${endTime - startTime} ms`);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching documents:', error);
        }
    };


    useEffect(() => {

        const fetchDocumentsFromLocalStorage = async () => {
            const filters = await getLocalFilter();
            if (filters) {
                setDocumentsFilter(filters);
                fetchDocuments(filters);
            } else {
                setDocumentsFilter({});
                fetchDocuments({});
            }
        };
        fetchDocumentsFromLocalStorage();

    }, []);

    const handleNavigate = (row) => {
        if (row._id) {
            navigate(`/documents/${row._id}`);
        }
    }


    const columnsDocuments = [
        { field: 'documentNumber', headerName: page.documentNumber, width: 150, editable: false },
        {
            field: 'documentType', headerName: page.documentType, width: 150, editable: false,
            valueGetter: (value) => {
                return ModelDocumentType.find(type => type.key === value)[language] || '';
            },
        },
        {
            field: 'issueDate', headerName: page.issueDate, width: 150, editable: false,
            valueFormatter: (value) => {
                return dayjs(value).format('DD/MM/YYYY') || '';
            }
        },
        {
            field: 'customer', headerName: page.customer, width: 200, editable: false,
            valueGetter: (customer) => {
                return customer?.name ? customer?.name : '';
            }
        },
        // {
        //     field: 'customer.name', headerName: page.customer, width: 200, editable: false,
        //     valueGetter: (params) => {
        //         return params.row?.customer ? params.row.customer?.name : '';
        //     }
        // },
        {
            field: 'documentStatus', headerName: page.documentStatus, width: 150, editable: false,
            valueGetter: (value) => {
                return ModelDocumentStatus.find(status => status.key === value)[language] || '';
            }
        },
    ]


    const TextFieldProps = {
        variant: 'outlined',
        size: 'small',
        sx: { width: '100%' },
        InputLabelProps: {
            shrink: true,
        },
        autoComplete: "off"
    }


    return (
        <>

            <MainMenu currentPage={'documents'} />
            <Box sx={{ mb: 0, py: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='overline' component='h1' sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                    {page.title}
                </Typography>

                {/* <Link to={`/documents/new`} style={{ textDecoration: 'none', color: 'inherit' }}> */}
                <Button variant='outlined' onClick={() => { setPopupDocument(true) }} >{btns.add}</Button>
                {/* </Link> */}
            </Box>

            {/* search barre  */}
            <Box sx={{ mb: 2, py: 2, display: 'flex', gap: 2, justifyContent: 'space-between', alignItems: 'center' }}>

                <TextField
                    label={ModelDocumentData.documentNumber[language]}
                    value={documentsFilter.documentNumber || ''}
                    onChange={(e) => updateDocumentsFilter({ field: 'documentNumber', value: e.target.value })}
                    {...TextFieldProps}
                />




                <Box sx={{ display: 'flex', gap: 1 }}>

                    <Button variant='outlined' onClick={clearDocumentsFilter} >{btns.clear}</Button>
                    <Button variant='outlined' onClick={() => {
                        console.log(documentsFilter)
                        fetchDocuments(documentsFilter)
                    }} >{btns.search}</Button>
                </Box>




            </Box>



            {loading && <LinearProgress sx={{ mb: 2 }} />}

            {!loading && <Box sx={{ height: 520, width: '100%' }}>
                <Box sx={{ width: '100%' }}>
                    <DataGrid
                        rows={documents}
                        getRowId={(row) => row._id}
                        columns={columnsDocuments}

                        showToolbar={true}
                        slotProps={{
                            toolbar: {
                                printOptions: { disableToolbarButton: true },
                            },
                        }}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 25,
                                },
                            },
                        }}
                        pageSizeOptions={[25]}
                        // checkboxSelection
                        disableRowSelectionOnClick
                        columnVisibilityModel={{
                            shipmentDirection: false, // Hide shipmentDirection column by default
                        }}
                        onRowClick={(params) => handleNavigate(params.row)}
                        sx={{
                            '& .MuiDataGrid-row:hover': {
                                cursor: 'pointer',
                            },
                            '& .MuiDataGrid-cell:focus': {
                                outline: 'none',
                            },
                            fontSize: '0.8rem',
                        }}
                    />
                </Box>
            </Box>
            }

            {popupDocument && <SelectDocumentType
                open={popupDocument}
                handleClose={handleClosePopupDocument} />}


        </>
    );
}


export default Documents;